<!-- 美田币兑换详情- -->
<template>
    <div class="biRecord-module">
        <div class="myorderlist">
            <div class="status-box">
                <img class="icon" v-if="orderStatus == 1" src="../../../assets/img/gou.png" alt="" />
                <img class="icon-car" v-if="orderStatus == 2" src="../../../assets/img/alreadygou.png" alt="" />
                <img class="icon-oredered" v-if="orderStatus == 3" src="../../../assets/img/ordered.png" alt="" />
                <div class="status">
                    <div class="gray font34" v-if="orderStatus == 1">已下单</div>
                    <div class="gray font34" v-if="orderStatus == 2">已发货</div>
                    <div class="gray font34" v-if="orderStatus == 3">已完成</div>
                  <div class="gray font34" v-if="orderStatus === -1">已取消</div>
                    <div class="Grey font24 mt11">{{detailData.updateDate}}</div>
                </div>
            </div>
            <div class="myorderitem WhiteBg" v-for="item,index in detailData.goods" :key="index">
                <div class="myordercon">
                    <div class="orderitem flex-row">
                        <img class="orderimg" mode="aspectFill" :src="item.listImg" alt="" />
                        <div class="con flex-col margin-left-xs flex-1">
                            <div class="font30 gray ellipsis2">{{item.title}}</div>
                        </div>
                        <div class="price margin-left-xs">
                            <div class="font30 gray" v-if="item.isAll != 1">{{item.price}}</div>
                            <div class="font30 gray" v-else>1-9999</div>
                            <div class="font24 Grey mt11">x {{item.number}}</div>
                        </div>
                    </div>
                    <div class="conprice font26 gray padding-left-xs">
                        共消耗美田币:
                        <span class="red font28">{{detailData.goodsAmount}}</span>
                    </div>
                </div>
            </div>
            <div class="info-box">
                <div class="infotit gray font34">订单信息</div>
                <div class="info">
                    <div class="line mb-10">
                        <span class="infotxt gray">订单号</span>
                        <span class="infotime gray">{{detailData.orderNo}}</span>
                    </div>
                    <div class="line mb-10">
                        <span class="infotxt gray">兑换时间</span>
                        <span class="infotime gray" @click="copy">{{detailData.createDate}}</span>
                    </div>
                    <div class="line mb-10 flex-start">
                        <span class="infotxt gray">收货地址</span>
                        <span class="infotime gray">{{detailData.address}}</span>
                    </div>
                    <div class="line mb-10">
                        <span class="infotxt gray">物流公司</span>
                        <span class="infotime gray">{{detailData.exName}}</span>
                    </div>
                    <div class="line mb-10">
                        <span class="infotxt gray">物流单号</span>
                        <div class="infotime gray order-span">
                            <div>{{detailData.exId}}</div>
                            <van-tag id="exId" plain type="primary" v-if="detailData.exId" @click="copy(detailData.exId)">复制
                            </van-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="orderStatus == 2" class="orderbottom flex-row flex-y-center ">
            <button class="buy font28 White" @click="sureSubmit">确认收货</button>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast, Dialog } from 'vant'

export default {
    name: 'orderDetail',
    components: {},
    data() {
        return {
            detailData: {}, //详情
            orderStatus: 0, // 状态
            id: ""
        }
    },
    mounted() {
        this.id = this.$route.query.id
        this.getList();
    },
    methods: {
        // 兑换详情
        getList() {
            request({
                url: `/order/detail?orderId=` + this.id,
                method: "get",
            })
                .then((res) => {
                    this.detailData = res.data;
                    this.orderStatus = res.data.orderStatus
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })

        },
        // 确认收货提醒
        sureSubmit() {
            Dialog.confirm({
                title: "提示",
                message: "是否确认收货？",
            })
                .then(() => {
                    this.submit();
                })
                .catch(() => { });
        },
        // 确认收货
        submit() {
            request({
                url: `/order/updateStatus?orderId=` + this.id,
                method: "get",
            })
                .then((res) => {
                    Toast({ position: 'top', message: '确认收货成功' })
                    this.getList();
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        copy(exId) {
            this.$copyText(exId).then(function (e) {
                Toast({ position: 'top', message: '复制成功' })
            }, function (e) {
                Toast({ position: 'top', message: '复制失败' })

            })
        }
    },
}
</script>

<style  scoped lang="less">
.biRecord-module {
    height: 100%;
    background: #f5f6f5;
}
.mt11 {
    margin-top: 11px;
}
.gray {
    color: #35434c;
}
.red {
    color: #ee4c4c;
}

/* 状态 */
.status-box {
    height: 151px;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding: 30px 20px;
    display: flex;
}

.icon {
    width: 32px;
    height: 32px;
    margin-top: 8px;
}
.icon-car {
    width: 37px;
    height: 32px;
    margin-top: 8px;
}
.icon-oredered {
    width: 32px;
    height: 36px;
    margin-top: 8px;
}
.status {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    margin-left: 20px;
}

.status view {
    flex: 1;
    display: flex;
    align-items: flex-end;
}

/* 列表 */
.myorderlist {
    padding: 20px 30px 10px;
}

.myorderlist .myorderitem {
    border-radius: 12px;
    margin-bottom: 20px;
}

.myorderitem .header {
    padding: 0 30px;
    height: 96px;
    line-height: 96px;
    border-bottom: 1px solid rgba(215, 215, 215, 0.3);
}

.myorderitem .myordercon {
    padding: 30px;
    border-bottom: 1px solid rgba(215, 215, 215, 0.3);
}

.myordercon .conprice {
    text-align: right;
    line-height: 40px;
    padding-top: 20px;
}

/* 执行按钮 */
.myorderbtn {
    padding: 30px;
    justify-content: flex-end;
}

.myorderbtn button {
    width: 180px;
    text-align: center;
    border-radius: 30px;
    font-size: 26px;
    line-height: 60px;
    margin: 0;
    background-color: #ffffff;
}

.myorderbtn button.cancel {
    border: 1px solid #d7d7d7;
    color: #999999;
}

.myorderbtn button.pay {
    border: 1px solid #bc8f79;
    color: #a56b4f;
    margin-left: 20px;
}

.orderimg {
    width: 180px;
    height: 180px;
}

.orderitem .price {
    width: 140px;
    text-align: right;
    word-break: break-all;
}

/* 订单信息 */
.info-box {
    width: 690px;
    min-height: 258px;
    background: #ffffff;
    border-radius: 12px;
    padding: 30px;
    box-sizing: border-box;
}

.infotit {
    height: 60px;
    line-height: 60px;
    font-weight: bold;
    margin-bottom: 40px;
}

.info {
    min-height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.info .line {
    flex: 1;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    margin-bottom: 30px;
}

.infotxt {
    width: 170px;
    font-size: 28px;
}

.infotime {
    text-align: right;
    flex: 1;
    font-size: 28px;
}

.orderbottom {
    position: fixed;
    bottom: 0;
    width: 750px;
    padding: 0 30px;
    height: 120px;
    box-sizing: border-box;
    z-index: 10;
    background-color: #fff;
    justify-content: flex-end;
}

.buy {
    width: 220px !important;
    height: 70px !important;
    text-align: center;
    background: #333f48;
    border-radius: 40px;
    margin: 0 !important;
    font-weight: normal;
}

.order-span {
    display: flex;
    justify-content: flex-end;
}

.van-dialog__button {
    flex: none !important;
    width: 50% !important;
}

.copy {
    width: 100px !important;
}
#exId {
    margin-left: 10px;
}
</style>